module.exports = __webpack_public_path__ + "img/logozsysmall.4ab5a1c7.png";